import { ExportTaskDialogComponent } from './../export-task-dialog/export-task-dialog.component';
import {Component, ElementRef, ViewChild} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-confirm-certificate-site',
  templateUrl: './confirm-certificate-site.component.html'
})
export class ConfirmCertificateSiteComponent{
  public pathSelect: string;

  constructor(private dialogRef: MatDialogRef<ExportTaskDialogComponent>,) { }
  
  submitConfirm(){
    this.dialogRef.close(true);
  }
}